export const subtitles = {
    "1": {
        "startTime": 0.1,
        "endTime": 4.35,
        "transcript": "Hello, testing. Testing. Are you getting any reading at all?",
        "translation": "Hello, testing. Testing. Are you getting any reading at all?"
    },
    "2": {
        "startTime": 7.58,
        "endTime": 12.51,
        "transcript": "Tau͡gaam quyanaqluteng taukut.",
        "translation": "But we are grateful to them."
    },
    "3": {
        "startTime": 15.92,
        "endTime": 28.29,
        "transcript": "Pitarkam unakellerkaakun tamakut cuculuki ayuqniarpegnata ilamteńek nukalpiaruyuumirluta.",
        "translation": "We should not be jealous of or envy those around us, wanting to be good hunters who catch a lot."
    },
    "4": {
        "startTime": 28.81,
        "endTime": 34.33,
        "transcript": "Umyuarteqerkaugut [?] niisnginarluku.",
        "translation": "We must ponder and listen to the [?]."
    },
    "5": {
        "startTime": 45.545,
        "endTime": 48.235,
        "transcript": "Am I doing the right thing to him?",
        "translation": "Am I doing the right thing to him?"
    },
    "6": {
        "startTime": 49.965,
        "endTime": 59.785,
        "transcript": "If we don't ask questions why he or another or the best of your friends...",
        "translation": "If we don't ask questions why he or another or the best of your friends..."
    },
    "7": {
        "startTime": 59.8,
        "endTime": 64.33,
        "transcript": "...avoided from a good friend or parent or wife or son.",
        "translation": "...avoided from a good friend or parent or wife or son."
    },
    "8": {
        "startTime": 65.92,
        "endTime": 71.38,
        "transcript": "So, we have to ask questions if we are...",
        "translation": "So, we have to ask questions if we are..."
    },
    "9": {
        "startTime": 71.385,
        "endTime": 75.605,
        "transcript": "...in their mind, to their trial and errors in time of life.",
        "translation": "...in their mind, to their trial and errors in time of life."
    },
    "10": {
        "startTime": 76.6,
        "endTime": 85.45,
        "transcript": "To where a person that scrutinizes the other people and their elders that have...",
        "translation": "To where a person that scrutinizes the other people and their elders that have..."
    },
    "11": {
        "startTime": 87.51,
        "endTime": 97.8,
        "transcript": "...can gain that knowledge to where, just lot of these elders just...",
        "translation": "...can gain that knowledge to where, just lot of these elders just..."
    },
    "12": {
        "startTime": 98.4,
        "endTime": 104.6,
        "transcript": "You will never know what you're [?], the trials and errors that you are doing",
        "translation": "You will never know what you're [?], the trials and errors that you are doing"
    },
    "13": {
        "startTime": 106.005,
        "endTime": 111.775,
        "transcript": "But you do not understand thinking you're doing the right thing up until you ask questions.",
        "translation": "But you do not understand thinking you're doing the right thing up until you ask questions."
    },
    "14": {
        "startTime": 113.075,
        "endTime": 122.045,
        "transcript": "What led her to [?], then left her on that island to be drowned still remains to be seen.",
        "translation": "What led her to [?], then left her on that island to be drowned still remains to be seen."
    },
    "15": {
        "startTime": 123.915,
        "endTime": 127.65,
        "transcript": "So, based on that story, you have to...",
        "translation": "So, based on that story, you have to..."
    },
    "16": {
        "startTime": 127.65,
        "endTime": 130.55,
        "transcript": "...want to do to seek the answers.",
        "translation": "...want to do to seek the answers."
    },
    "17": {
        "startTime": 132.215,
        "endTime": 143.055,
        "transcript": "Only through questions through your elders can you get knowledge and wisdom on how you're going to lead your own life.",
        "translation": "Only through quesionts through your elders can you get knowledge and wisdom on how you're going to lead your own life."
    },
    "18": {
        "startTime": 144.9,
        "endTime": 148.83,
        "transcript": "To take an example, you young people like to hunt.",
        "translation": "To take an example, you young people like to hunt."
    },
    "19": {
        "startTime": 149.46,
        "endTime": 151.29,
        "transcript": "You just can't go out there and...",
        "translation": "You just can't go out there and..."
    },
    "20": {
        "startTime": 152.92,
        "endTime": 161.52,
        "transcript": "[?] how you have to butcher it, you have to seek knowledge from your elders.",
        "translation": "[?] how you have to butcher it, you have to seek knowledge from your elders."
    },
    "21": {
        "startTime": 164.215,
        "endTime": 171.245,
        "transcript": "And if you don't ask any questions, seeing none of it, you just...",
        "translation": "And if oyu don't ask any questions, seeing none of it, you just..."
    },
    "22": {
        "startTime": 171.355,
        "endTime": 180.435,
        "transcript": "...imkuciuluni, tua-i-wa eneqak'ngaqluku man'a qaneryaraq qulirauguq.",
        "translation": "...it's, you know, I remember this traditional wisdom as a legend."
    },
    "23": {
        "startTime": 180.55,
        "endTime": 182.66,
        "transcript": "Mat'um nalliini maa-i eneqak...",
        "translation": "Remembering it now..."
    },
    "24": {
        "startTime": 182.68,
        "endTime": 187.5,
        "transcript": "Waniw' umyuarteqlemni Agayutem tauna ikayullrua quliraq.",
        "translation": "In my opinion, God helped with that legend."
    },
    "25": {
        "startTime": 189.315,
        "endTime": 195.185,
        "transcript": "Waten qanllruuq: \"Aren atama ima tanem, apa'urluma ima tanem...\"",
        "translation": "He said this: \"Didn't my father, didn't my grandfather...\""
    },
    "26": {
        "startTime": 195.22,
        "endTime": 197.66,
        "transcript": "...naugartesqellrukii.",
        "translation": "...wanted it to grow."
    },
    "27": {
        "startTime": 198.475,
        "endTime": 203.745,
        "transcript": "Tua-i-ll' nekevraartuq cugg'agpak naugarrluni, avayai yagglu...",
        "translation": "And then the spruce tree with the big [?] grew, its branches raised..."
    },
    "28": {
        "startTime": 203.755,
        "endTime": 205.565,
        "transcript": "...luni tua-i.",
        "translation": "...it [?]."
    },
    "29": {
        "startTime": 206.815,
        "endTime": 211.875,
        "transcript": "Tua-i tauna Agayutem ikayuraa, ikayullrua.",
        "translation": "God helped that."
    },
    "30": {
        "startTime": 212.09,
        "endTime": 217.97,
        "transcript": "Maa-i mat'um nalliini, tua-i-wa imumirpak wangkuta...",
        "translation": "These days, well, we have always..."
    },
    "31": {
        "startTime": 218.365,
        "endTime": 225.645,
        "transcript": "Apa'urluan taum umyugaa cagnitaciani tauna nekevraartuq nauguq Agayutem pisqeńgani.",
        "translation": "As his grandfather was struggling in his mind, that spruce tree grew as God commanded."
    },
    "32": {
        "startTime": 225.72,
        "endTime": 230.57,
        "transcript": "Tua-i tuaten pitaluku iqua nallunayukluku qanenritaqa.",
        "translation": "That's all, and I've not said the ending in case you may not know it."
    },
    "33": {
        "startTime": 231.325,
        "endTime": 232.775,
        "transcript": "There's another side to it.",
        "translation": "There's another side to it."
    },
    "34": {
        "startTime": 232.905,
        "endTime": 235.415,
        "transcript": "At the very last request.",
        "translation": "At the very last request."
    },
    "35": {
        "startTime": 238.975,
        "endTime": 242.575,
        "transcript": "A thought came to this woman, but her grandfather...",
        "translation": "A thought came to this woman, but her grandfather..."
    },
    "36": {
        "startTime": 242.82,
        "endTime": 245.21,
        "transcript": "And that's where Christianity comes in.",
        "translation": "And that's where Christianity comes in."
    },
    "37": {
        "startTime": 245.22,
        "endTime": 250.54,
        "transcript": "If you truly ask from the bottom of your heart, you'll get the answer of what you requested.",
        "translation": "If you truly ask from the bottom of your heart, you'll get the answer of what you requested."
    },
    "38": {
        "startTime": 253.225,
        "endTime": 256.175,
        "transcript": "Kituusit camiunguluten-llu?",
        "translation": "Who are you and where are you from?"
    },
    "39": {
        "startTime": 258.635,
        "endTime": 264.095,
        "transcript": "Tununermiunguunga, ategnqerrlua Carl, Carl Flynn.",
        "translation": "I'm from Tununak, and my name is Carl, Carl Flynn."
    },
    "40": {
        "startTime": 264.29,
        "endTime": 270.18,
        "transcript": "IRA-ni Council-at, IRA Council-aarulua Tununermi.",
        "translation": "I'm a part of the IRA Council in Tununak."
    },
    "41": {
        "startTime": 271.51,
        "endTime": 272.87,
        "transcript": "Tua-i wanigga...",
        "translation": "Now..."
    },
    "42": {
        "startTime": 273.025,
        "endTime": 275.485,
        "transcript": "Really? IRA Council? (Yes.)",
        "translation": "Really? IRA Council? (Yes.)"
    },
    "43": {
        "startTime": 276.94,
        "endTime": 288.31,
        "transcript": "Yaa, kitak' qanemciyaram ava-i qanrutkellerpetun qaillun ayagnillrua?",
        "translation": "Okay, so with telling stories as you've said, how did it start?"
    },
    "44": {
        "startTime": 288.83,
        "endTime": 296.5,
        "transcript": "Cali-llu ava-i-w' tua-i ciuqlikacaarmek qanllerpenek cali qanrutqerkut.",
        "translation": "Also, please tell us the very first thing you said again."
    },
    "45": {
        "startTime": 296.74,
        "endTime": 300.61,
        "transcript": "Pulenglluku, pulngarrluku au͡gna qanelqa.",
        "translation": "I'm going to repeat what I said."
    },
    "46": {
        "startTime": 300.83,
        "endTime": 310.73,
        "transcript": "Una wanigga quliraam ayagnera, ayagneqapiara",
        "translation": "The true beginning of this legend"
    },
    "47": {
        "startTime": 311.375,
        "endTime": 317.815,
        "transcript": "Ukanirpak elluarrluku qanrutkestaitetullruuq avani.",
        "translation": "There was never a compeltely accurate telling back then."
    },
    "48": {
        "startTime": 318.48,
        "endTime": 324.7,
        "transcript": "Quliraam ayagnillra yaaqsigtuq cakneq waken wanigg' ernermek.",
        "translation": "The beginning of a legend is very far from this day."
    },
    "49": {
        "startTime": 328.595,
        "endTime": 332.645,
        "transcript": "Nuna mamkitellruuq ak'a tamaani.",
        "translation": "The land was thin a long time ago."
    },
    "50": {
        "startTime": 334.555,
        "endTime": 340.945,
        "transcript": "Yucuayagaat-llu tamakut tamaani pitullruluteng ak'a nuna mamkitellrani.",
        "translation": "And the little people existed back then when the land was thin a long time ago."
    },
    "51": {
        "startTime": 342.145,
        "endTime": 352.645,
        "transcript": "Cali-llu apqait aipait egacuayiit makut cali yugtun ayuqelriit kesianek paivngaluteng",
        "translation": "And their companions that they call egacuayiit that look human were always common"
    },
    "52": {
        "startTime": 354.09,
        "endTime": 359.21,
        "transcript": "Quliraam tamaa-i civuani.",
        "translation": "Before the time of that legend."
    },
    "53": {
        "startTime": 359.33,
        "endTime": 365.28,
        "transcript": "Wanigga watua qanerturallruunga waten:",
        "translation": "Now, I've been saying this:"
    },
    "54": {
        "startTime": 366.7,
        "endTime": 378.31,
        "transcript": "Puqikuvet, puqilriarukuvet, ayuqucin tamalkuan nallunrilkuvgu, yuum-llu ayuqucirkaa assilria nallunrilkuvgu",
        "translation": "If you are smart, if you know the entirety of what you're like, and if you know how a good person should be"
    },
    "55": {
        "startTime": 379.79,
        "endTime": 383.34,
        "transcript": "Tua-i nerucengaaqngamken qanrutamken.",
        "translation": "I'm telling you because you're my [?great-great-great-grandchild]."
    },
    "56": {
        "startTime": 390.33,
        "endTime": 401.57,
        "transcript": "Quliramek taqucugngauten yuum elluarrluni egilratkaanek yuk'egciluni.",
        "translation": "You can make a legend that will help a person live well as a good person."
    },
    "57": {
        "startTime": 402.865,
        "endTime": 411.645,
        "transcript": "Quli'irmek niiskuvet qanerturallran nalliikun akurturyaqunaku.",
        "translation": "If you hear a legend, do not accept it as you hear it."
    },
    "58": {
        "startTime": 412.89,
        "endTime": 423.67,
        "transcript": "Elpenun tau͡gaam tusnganguarturtelluku kesianek qanerturallra tamalkuan taringengnaqutekekiu taumun elpenun.",
        "translation": "Instead, pretend that everything he is talking about is relevent to yourself, and try to understand it as it applies to you."
    },
    "59": {
        "startTime": 425.685,
        "endTime": 432.405,
        "transcript": "Umyuartukuvet tua-i waten umyuartequ'urciquten: \"Wii qanrutaanga.\"",
        "translation": "If you're wise, you will think like this: \"He is telling it to me.\""
    },
    "60": {
        "startTime": 434.64,
        "endTime": 440.4,
        "transcript": "Uucetun qanerturallratun quliraq tamana cucukekuvgu assilriarukan",
        "translation": "If you strive to be like that legend he is talking about if it is good"
    },
    "61": {
        "startTime": 441.405,
        "endTime": 452.025,
        "transcript": "Qanerturallra elpet ayuquciqsuumirluku elpenun tusnganguartelluku quliraq ayuquskiu.",
        "translation": "If you want to be like what he is talking about, treat that legend as if it applies to yourself."
    },
    "62": {
        "startTime": 455.9,
        "endTime": 467.53,
        "transcript": "Cali-llu quliraam ilii, quliraam ilii, quliraat ilait yuum ayuqucianun tusngaut.",
        "translation": "Also, some legends apply to what people are like."
    },
    "63": {
        "startTime": 470.97,
        "endTime": 475.14,
        "transcript": "Anglanaqluteng ucurnaqluteng-llu.",
        "translation": "They are fun and amazing."
    },
    "64": {
        "startTime": 478.47,
        "endTime": 486.49,
        "transcript": "Tau͡gaam ucurnaqluteng anglanarqelriit yuum ayuqucianun tusnganrilkata",
        "translation": "But if the fun and amazing ones are not related to what people are like"
    },
    "65": {
        "startTime": 486.585,
        "endTime": 497.775,
        "transcript": "Tamakut calliggluki assilriarakun, assilriara tau͡gaam akurtuumakiu kemegpenun ircaqurpenun itertelluku",
        "translation": "Discard those and only accept the good things into your flesh and heart"
    },
    "66": {
        "startTime": 498.135,
        "endTime": 503.505,
        "transcript": "Ayuquciqnaluku elpet piyaureskuvet ukaniku.",
        "translation": "So that you will become like that when you are able in the near future."
    },
    "67": {
        "startTime": 504.655,
        "endTime": 512.145,
        "transcript": "Piyaureskuvet, allakarpet yuungnaqengkuvet ayuquciqnaluku cucukekiu.",
        "translation": "When you are able and you start trying to live your own life, choose to be like that."
    },
    "68": {
        "startTime": 512.775,
        "endTime": 517.035,
        "transcript": "Quliraam ilii arcaqalriaruuq yugmun tusngallermini.",
        "translation": "Some legends especially apply to people."
    },
    "69": {
        "startTime": 519.88,
        "endTime": 541.3,
        "transcript": "Yuum ilii, yuum iliin wii ilama, nakmiin acama qulirillruakut wangkuta anngaqelriani pingayuni quliriarkaqngamikut.",
        "translation": "One person, one of my relatives, my own paternal aunt told us three brothers legends because she was to tell us legends."
    },
    "70": {
        "startTime": 542.001,
        "endTime": 547.073,
        "transcript": "Anglaniluta niicugniluku. Anglanilua niicugnillruaqa.",
        "translation": "We had fun listening to her. I had fun listening to her."
    },
    "71": {
        "startTime": 549.728,
        "endTime": 555.128,
        "transcript": "Taqngami-llu, iquklican quliraq tauna",
        "translation": "And when she was done, when that legend was over"
    },
    "72": {
        "startTime": 555.474,
        "endTime": 563.91,
        "transcript": "Atakurrlainarmi tau͡gaam caarkaunrirqameng inartaqameng wanigga qavarpailegmeng quliritullruut.",
        "translation": "They only told legends in the evening when they had no more chores to do, before going to sleep when they had gone to bed."
    },
    "73": {
        "startTime": 564.306,
        "endTime": 568.942,
        "transcript": "Quliraq-llu tamana qavautekluku unugpak tayima.",
        "translation": "And they fell asleep to that legend all night."
    },
    "74": {
        "startTime": 570.973,
        "endTime": 578.124,
        "transcript": "Tamaa-i quliritullruut yugmun tut'evkangnaqluku tau͡gaam, yuum ayuqucianun.",
        "translation": "They would tell legends only as they applied to people, what people should be like."
    },
    "75": {
        "startTime": 578.983,
        "endTime": 584.265,
        "transcript": "Quliraq tauna acagglugairutma qulirikiikut",
        "translation": "My late paternal aunt told us that legend"
    },
    "76": {
        "startTime": 585.147,
        "endTime": 595.183,
        "transcript": "Taqngami-llu, iquklicamiu qanerluni, angu-gguq wangkuta quliraqsaqunata ilamteńun.",
        "translation": "When she was done and finished that story, she said that we should never tell those legends to our peers."
    },
    "77": {
        "startTime": 596.363,
        "endTime": 599.736,
        "transcript": "Inerqurluta quliraqesqevkenaku ilamteńun.",
        "translation": "She admonished us against telling that legend to our peers."
    },
    "78": {
        "startTime": 600.83,
        "endTime": 605.494,
        "transcript": "Wangkuta tau͡gaam, pikesqelluku wangkutnun.",
        "translation": "Instead, she said that it should be ours."
    },
    "79": {
        "startTime": 607.15,
        "endTime": 608.05,
        "transcript": "Tangrriu.",
        "translation": "You see?"
    },
    "80": {
        "startTime": 608.328,
        "endTime": 611.91,
        "transcript": "Quliraq man'a qumlinarqenrituq.",
        "translation": "A legend like this is not a cause for irritation."
    },
    "81": {
        "startTime": 612.969,
        "endTime": 617.487,
        "transcript": "Qangkun pirpaumiuq. Arcaqalriarumiuq.",
        "translation": "It is also something that has always been. It is also important."
    },
    "82": {
        "startTime": 620.006,
        "endTime": 623.76,
        "transcript": "Arcaqalriarumiuq quliraq man'a.",
        "translation": "A legend like this is also important."
    },
    "83": {
        "startTime": 627.24,
        "endTime": 635.898,
        "transcript": "TV-nek tanglartuci. TV-t kesianek atakuneq tamalkuan tangvalaraci.",
        "translation": "You watch TV. You watch TV every evening."
    },
    "84": {
        "startTime": 636.465,
        "endTime": 644.935,
        "transcript": "Wii TV-t piyaurcata TV-t tangvalaranka anglanilua.",
        "translation": "When TVs started to come around, I enjoy watching TV."
    },
    "85": {
        "startTime": 645.974,
        "endTime": 651.987,
        "transcript": "Yaatiikun-llu, anglanillma yaatiikun wangnun tusngavkarluki.",
        "translation": "And aside from that, aside from having fun, I apply them to myself."
    },
    "86": {
        "startTime": 653.547,
        "endTime": 663.256,
        "transcript": "Ayuquciqsunailnguq ayuquciqsuumiinaku calligtellriatun ayuqutek'la'rqa.",
        "translation": "I do not want to be like what people should not be like and discard it."
    },
    "87": {
        "startTime": 663.97,
        "endTime": 667.47,
        "transcript": "Ayuquciqsunarqelria-llu wiinga teguluku.",
        "translation": "And I take upon what a person should be like."
    },
    "88": {
        "startTime": 668.083,
        "endTime": 673.41,
        "transcript": "Wangnun ayuqucimnun elliluku ayuqnianarqelria.",
        "translation": "I apply what a person should be like to myself."
    },
    "89": {
        "startTime": 675.226,
        "endTime": 683.626,
        "transcript": "Qanemcim quliraq niiskuvgu niicugnikiu cakneq, elpenun yuvriutekluku tuaten.",
        "translation": "If you hear a story or legend, listen to it completely, and compare yourself to it."
    },
    "90": {
        "startTime": 683.685,
        "endTime": 687.921,
        "transcript": "Ayuqucin nallunritan kingunren au͡gna pellulleq.",
        "translation": "You know what you were like in the past."
    },
    "91": {
        "startTime": 689.175,
        "endTime": 695.175,
        "transcript": "Kingunerpenun elliluku, elpenun elliluku ayuquciqluku niicugniurqiu.",
        "translation": "Apply it to your past, apply it to yourself as you listen to it."
    },
    "92": {
        "startTime": 697.54,
        "endTime": 707.922,
        "transcript": "Tuani-wa kiimelamegnuk qanrutarkaqngamken makunek ellangcarturarkaqngamken ellangcarturamken.",
        "translation": "Since we are alone and I must talk to you and give you lessons, I am giving you lessons."
    },
    "93": {
        "startTime": 708.211,
        "endTime": 711.147,
        "transcript": "Camek-llu anuraqutmek caunii.",
        "translation": "And I have no such restraints to do so."
    },
    "94": {
        "startTime": 712.285,
        "endTime": 713.076,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "95": {
        "startTime": 713.626,
        "endTime": 714.49,
        "transcript": "Is that...",
        "translation": "Is that..."
    },
    "96": {
        "startTime": 716.259,
        "endTime": 721.141,
        "transcript": "Yaa, amlleriuq qanemcikan.",
        "translation": "Yes, you've told enough."
    },
    "97": {
        "startTime": 721.65,
        "endTime": 728.905,
        "transcript": "Atam quliraam ilakuggaanek niitellrunrilkevnek catailngurmek wani cali ilaqernaurqa.",
        "translation": "Look, let me add a missing part of the legend that you haven't heard."
    },
    "98": {
        "startTime": 730.639,
        "endTime": 734.448,
        "transcript": "Quliraq nulirqelriik.",
        "translation": "The legend is about a married couple."
    },
    "99": {
        "startTime": 737.876,
        "endTime": 749.37,
        "transcript": "Nulirra tauna ellmini canganaunani arnauguq, arnaulliniuq.",
        "translation": "The wife is a woman that did not consider herself objectionable."
    },
    "100": {
        "startTime": 749.538,
        "endTime": 751.983,
        "transcript": "Irnianglutek-llu mikelngucuarmek.",
        "translation": "And they bore a small child."
    },
    "101": {
        "startTime": 753.342,
        "endTime": 759.324,
        "transcript": "Arnaq tauna ellmini cangaunani, uiminun angutminun cangakutaunani.",
        "translation": "That woman didn't consider herself objectionable, and had no qualms with her husband."
    },
    "102": {
        "startTime": 759.681,
        "endTime": 765.926,
        "transcript": "Angutiin tau͡gken cangayutii amllerrluni taumun nuliaminun.",
        "translation": "THe man however, had many qualms with his wife."
    },
    "103": {
        "startTime": 767.429,
        "endTime": 776.247,
        "transcript": "Angutiin-llu nalluvkarluku tamana cangakutni nuliaminun, elliin-llu nalluluku canganarqucini.",
        "translation": "And the man didn't let his wife know of his qualms, and she didn't know that she was objectionable."
    },
    "104": {
        "startTime": 776.583,
        "endTime": 780.128,
        "transcript": "Erucim iliini ayautaa qayakun unayaqluku.",
        "translation": "At the dawning of one day, he invited her to travel with a kayak."
    },
    "105": {
        "startTime": 781.532,
        "endTime": 795.899,
        "transcript": "Qikertamun-llu mermi imarpigmi mer'em patutukiinun elliluku qapilaarrluni, clam-alluni.",
        "translation": "And then he left her on an island in the sea that would be covered with water, and she dug for clams, qapilaat."
    },
    "106": {
        "startTime": 799.618,
        "endTime": 809.359,
        "transcript": "Anglaniluni tua-i tauna nulirra nunaniryugluni piinanrani piqertuq angutii una ayalria uterrluni.",
        "translation": "As the wife was having fun and enjoying herself, she realized that her husband was traveling away going back home."
    },
    "107": {
        "startTime": 809.891,
        "endTime": 814.299,
        "transcript": "\"Au͡gsuurluuq,\" alangaallagluni, \"au͡gsuuq, waqaa tua-i unitarpenga?\"",
        "translation": "\"Hey you,\" she was surprised, \"hey, are you leaving me?\""
    },
    "108": {
        "startTime": 815.771,
        "endTime": 823.796,
        "transcript": "\"Tua-i canganarqucin qangvaq aipaqsaguqaanerpenek, aipaqsaguqaanemegnuk",
        "translation": "\"With all of the qualms I've had with you since we married some time ago"
    },
    "109": {
        "startTime": 824.17,
        "endTime": 827.162,
        "transcript": "\"Canganarqucin akiliqurarru tuani.",
        "translation": "\"Pay for all of your objectionable ways there."
    },
    "110": {
        "startTime": 827.85,
        "endTime": 831.934,
        "transcript": "\"Nangtarpenga umyuamkun. Aipaqsuumiirutamken.\"",
        "translation": "\"You are tormenting my mind. I do not want to be married to you anymore.\""
    },
    "111": {
        "startTime": 832.584,
        "endTime": 835.109,
        "transcript": "Unilluku nalitukiinun mer'em.",
        "translation": "He left here where the water would cover it."
    },
    "112": {
        "startTime": 836.423,
        "endTime": 841.264,
        "transcript": "Tua-i tauna-qaa tua-i cucukluku ayuqucingqerciquten elpet?",
        "translation": "Would you envy and choose to be like her?"
    },
    "113": {
        "startTime": 841.872,
        "endTime": 850.339,
        "transcript": "Canganaqsukluten umyuarteqkuvet elders-aat ullagluki apqauqiki.",
        "translation": "Ifyou think you're objectionable, go to the elders and ask them questions."
    },
    "114": {
        "startTime": 850.357,
        "endTime": 856.524,
        "transcript": "Apqaulaqiki. Apqaurutkairupailegpet arnassagarciquten.",
        "translation": "Ask them questions. Before you run out of questions, you'll become an old woman."
    },
    "115": {
        "startTime": 857.531,
        "endTime": 859.197,
        "transcript": "Tuaten tua-i pitalii.",
        "translation": "Let me stop there."
    },
    "116": {
        "startTime": 859.344,
        "endTime": 860.26,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "117": {
        "startTime": 861.008,
        "endTime": 862.608,
        "transcript": "Quyanaqvaa. (Amllertuq-qaa?)",
        "translation": "Thank you so much. (Is that enough?)"
    },
    "118": {
        "startTime": 862.613,
        "endTime": 863.338,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "119": {
        "startTime": 863.63,
        "endTime": 864.772,
        "transcript": "Yaa, quyana.",
        "translation": "Okay, thank you."
    }
};